import type { ICartLine } from '~/modules/cart/types/cart-types';
import type { IProduct } from '~/modules/catalog/types/product';

const getGroupProduct = (line: ICartLine, partial?: boolean, toProduct?: boolean) => {
  const product = {
    id: line.product_id,
    pictures: [line.picture || ''],
    url: line.url,
    name: line.name,
    sku: line.sku,
  };

  if (partial) return product;

  return {
    ...product,
    can_buy: line.available,
    stock_count: toProduct ? line.total_stocks.amount : line.quantity.amount,
    regular_price: line.regular_price,
    final_price: line.final_price,
    can_return: line.can_return,
    offer: { id: line.offer_id, size: line.offer_size ?? undefined },
  };
};

export default (line: ICartLine, partial?: boolean, toProduct?: boolean): IProduct => ({
  id: line.product_id,
  line_id: line.id,
  selected_additional: line.selected_additional,
  additional_products: line.additional_products,
  constructor_parts: line.constructor_parts,
  group_products: [
    getGroupProduct(line, partial, toProduct),
  ],
});
